export default "__VITE_ASSET__CViCCJaN__"